import type { ProfileAddressWithTypeId } from "web_myplann/Profile/Types/ProfileAddressWithTypeId";

export enum ProfileAddressTypeId {
	Permanent = 1,
	Contact = 2,
}

export const getProfileAddresses = (
	addresses?: ProfileAddressWithTypeId[],
) => ({
	permanentAddress: addresses?.find(
		(address) => address.typeId === ProfileAddressTypeId.Permanent,
	),
	contactAddresses: addresses?.filter(
		(address) => address.typeId === ProfileAddressTypeId.Contact,
	),
});
